import { ClampContainerMixin } from 'common/components/Typography';
import variables from 'common/config/variables';
import { Epg } from 'common/constants/data-types';
import { TestableComponent } from 'common/interfaces';
import { getScalablePixel } from 'common/utils';
import GlobalStyle from 'common/utils/GlobalStyle';
import { isEmpty } from 'lodash';
import { getEpisodeInfoText } from 'Player/controls/utils';
import React from 'react';

GlobalStyle.inject`
  .description-subtitle {
    ${ClampContainerMixin({ lines: 1 })}
    font-size: ${getScalablePixel(26)}px;
    color: ${variables.font_color_c};
  }
`;

interface DescriptionSubtitleProps extends TestableComponent {
  numeration?: Epg['numeration'];
  originaltitle?: Epg['originaltitle'];
  children?: string;
}

function DescriptionSubtitle({
  children,
  numeration,
  originaltitle,
  testId
}: DescriptionSubtitleProps) {
  if (children) {
    return <span className="description-subtitle">{children}</span>;
  }

  const getSubtitle = () => {
    try {
      const episodeInfoText = getEpisodeInfoText(numeration);
      if (isEmpty(episodeInfoText)) return originaltitle || '';
      const episodeInfo = `${episodeInfoText} · ` || '';
      return episodeInfo + originaltitle;
    } catch (error) {
      return '';
    }
  };

  return (
    <span data-test-id={testId || 'description-subtitle'} className="description-subtitle">
      {getSubtitle()}
    </span>
  );
}

export default React.memo(DescriptionSubtitle);
